import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperiencePhoneConfigurationRoute: InvariantJiraRoute = {
	name: 'csm-experience-phone-configuration',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/phone',
	exact: true,
};
